<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Centro de Distribuição"
                icon="el-icon-office-building"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </template>
            </MacroSubHeader>

            <!-- Filters -->
            <div class="d-flex align-items-center justify-content-between px-3 mt-3" :style="{ gap: '20px' }">
                <div class="d-flex align-items-center" :style="{ gap: '8px', width: '375px' }">
                    <el-input
                        v-model="filters.search"
                        size="small"
                        placeholder="Buscar regiões"
                        prefix-icon="el-icon-search"
                        clearable
                        :style="{ maxWidth: '375px' }"
                        @keyup.enter.native.prevent="setFiltersregiaoCdList()"
                    />

                    <el-button
                        size="small" 
                        type="primary"
                        circle
                        @click="setFiltersregiaoCdList()"
                    >
                        <i class="el-icon-search"></i>
                    </el-button>
                </div>

                <div class="d-flex justify-content-end">
                    <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                        <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="latest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-top mr-2"></i>
                                    Mais Recentes
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item command="oldest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-bottom mr-2"></i>
                                    Mais Antigos
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>

            <CardBase>
                <CdList ref="cdListView"/>
            </CardBase>
        </CardBase>

        <!-- CdCreateModal -->
        <CdCreateModal ref="cdCreateModal" @created="handleDispatch"/>
    </div>
</template>

<script>    
    //Components
    import 
    {
        Dropdown,
        DropdownMenu,
        DropdownItem
    } from 'element-ui'

    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";
    import CdCreateModal from "@/components/_macro/cd/CdCreateModal.vue";
    import CdList from "@/components/_macro/cd/CdList.vue";

    export default {
        name: "centros-distribuicao",
        data() {
            return {
                filters: {
                    search: '',
                    orderBy: 'latest',
                }
            }
        },
        methods: {
            openModal() {
                this.$refs.cdCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.cdListView.fetch();
            },
            /**Filters */
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },
            setFiltersregiaoCdList() {
                this.$set(this.$refs.cdListView.filters, 'search', this.filters.search);
            }, 
        },
        watch: {
            "filters.orderBy": {
                handler(_newValue, _oldValue) {
                    this.$set(this.$refs.cdListView.filters, 'orderBy', _newValue);
                }
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            CdList,
            CdCreateModal,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/centro_distribuicao/index.vue